export type TriggerSource = string;
export const GLOBAL_CREATE_BUTTON: TriggerSource = 'global-create-button';
export const KEYBOARD_SHORTCUT: TriggerSource = 'keyboard-shortcut';
